import React, { Component } from 'react';
import cookie from 'react-cookies';

export default class SessionUser extends Component {

    constructor(props){
        super(props);
        this.state = {
            security: cookie.load('user'),
            loading: false,
            logout: false,
        } 
      }

    handleLogout(){
        localStorage.clear();
        localStorage.setItem("usermenu", null);
        localStorage.setItem("user", null);
        cookie.remove('usermenu', { path: '/' });
        cookie.remove('user', { path: '/' });
        window.location.href='/';
    }

    render() {
        return (
            <div className="btnSesion">
              <span>{this.state.security.sUsuNombre}</span>
              <a href="" onClick={(event) => this.handleLogout(event)}/>
            </div>
        )
    }
}
